import { render, staticRenderFns } from "./push2.vue?vue&type=template&id=1693c7eb&"
import script from "./push2.vue?vue&type=script&lang=js&"
export * from "./push2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports